import React, { useEffect, useState } from "react";
import {
  Grid,
  // Container,
  Box,
  Typography,
  Button,
} from "@mui/material";

import { useSnackbar } from "notistack";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import ModalDialog from "../ModalDialog.js";
import PostRequest from "../../components/apiConnections/postRequest.js";
import CircularProgress from "../CircularProgress.js";
import Loader from "../../Loader.js";
function ComplianceScoring({setCategoryValue}) {

  const data = useParams();
  const [open, setOpen] = React.useState(false);
  const [assessmentId, setAssessmentId] = useState(data.id);
  // const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { enqueueSnackbar } = useSnackbar();
  // const userEmail = window.localStorage.getItem("userEmail");
  const [securityControl, setSecurityControl] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    getQuestionnaire();
  }, []);

  const getQuestionnaire = async () => {
    setLoader(true);
    const payload = {
      assessment_id: assessmentId,
    };
    try {
      const refreshToken = await PostRequest(
        `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_REFRESH_TOKEN}`,
        {},
        {},
        "refreshToken"
      );
      if (refreshToken) {
        const endpoint = process.env.REACT_APP_GET_QUESTIONNAIRE_BY_VENDOR;
        await PostRequest(
          `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${endpoint}`,
          payload
        )
          .then((res) => {
            let response = res.data.data;
            Object.entries(response).map((key, val) => {
              if (key[0] === "data") {
                let mainArr = [];
                Object.entries(key[1]).map((k, v) => {
                  let arrObj = {};
                  const lengthQues = k[1].question.length;
                  arrObj['category'] = k[1].category;
                  arrObj['questionsLength'] = lengthQues;
                  if (response.setType === "custom" || response.setType === "customAdmin") {
                    let count = 0;
                    let score = 0;
                    k[1].question.map((item, i) => {
                      if (item.que?.optionType === "MCQ") {
                        count = count + item.que?.options?.length * 5
                        item.que.options?.forEach((option, j) => {
                          if (item.ans.includes(`${j + 1}`)) {
                            score = score + option?.score
                          }
                        })
                      } else {
                        count = count + 5;
                        item.que?.options?.forEach((option, j) => {
                          if (item.ans === option.title) {
                            score = score + option?.score
                          }
                        })
                      }
                    })
                    arrObj['percent'] = ((score / count) * 100).toFixed(0);
                  } else {
                    let count = 0;
                    k[1].question.map((item, index) => {
                      if (item.ans === "Yes") {
                        count++;
                      }
                    })
                    arrObj['correctAns'] = count;
                    arrObj['percent'] = ((count / lengthQues) * 100).toFixed(0);
                  }
                  mainArr.push(arrObj);
                })
                setSecurityControl(mainArr);
              }
            })
            setLoader(false);
          })
          .catch((err) => {
            enqueueSnackbar("Details not find.", {
              variant: "error",
            });
            setLoader(false);
          });
      } else {
        window.location.href = "/";
      }
    } catch (error) {
      enqueueSnackbar("Details not find.", { variant: "error" });
      setLoader(false);
    }
  };
  const ModalContent = () => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 600,
      bgcolor: "background.paper",
      boxShadow: 24,
      textAlign: "center",
      borderRadius: "15px",
      p: 4,
    };
    return (
      <Box sx={style}>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          {/* <img src={MailSend} alt="icon" /> */}
          <h2 className="send-assessments">Send Assessment to the vendor?</h2>
        </Typography>
        <Grid item xs={12} md={12} lg={12} className="center-vendor">
          <Button
            variant="contained"
            className="click-to-begin m-l model-btns cancel-btn"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="click-to-begin model-btns"
            onClick={handleClose}
          >
            Send
          </Button>
        </Grid>
      </Box>
    );
  };
  const handleGridClick = (index) => {
    setCategoryValue(index); 
  };
  return (
    <>
        <Loader show={loader} />
      <Helmet>
        <title> Security Control | Genesis Platform</title>
      </Helmet>
      <>
      <h3 className="category-score-text-heading">Category Scoring</h3>
        <Box sx={{paddingBottom:"22px"}}>
            <Grid container spacing={3}>
              {securityControl.map((item, index) => (
                <Grid item xs={12} md={4} lg={4} className="flex-align" key={index}  onClick={() => handleGridClick(index)}>
                  <div className="gdpr-box Category-Score-box">
                  <h3>{item.category}</h3>
                    <CircularProgress className="loader-custom-class-new"                
                    percent={item.percent}
                    title={item.category}
                    type="category"
                  />
                  </div>
                </Grid>
              ))}
            </Grid>
        </Box>

        <ModalDialog
          handleClose={handleClose}
          open={open}
          contentData={ModalContent()}
        />
      </>
    </>
  );
}

export default ComplianceScoring;
